import { useContext, useEffect, useState } from 'react';
import { NotificationContext } from 'src/context/NotificationContext';
import { getLocalStorageItem } from 'core/helpers';
import { fetchUserNotificationPreferences, isAdminUser } from 'src/utils/UserUtils';
import { formatDate } from 'src/utils/Date&TimeUtils';
import navhelper from 'core/navhelper';
import { pushNotification } from 'src/utils/NotificationUtils';
import Dialog from './Dialog';
import ToastNotification from './Toast';

const NotificationAlert = () => {
    const { message, timeOffRequest, setTimeOffRequest, setMessage } = useContext(NotificationContext);
    const loggedinUser = getLocalStorageItem("loggedinUser");
    const { setNotificationClicked } = useContext(NotificationContext);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [confirmText, setConfirmText] = useState("");
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogRoute, setDialogRoute] = useState("");
    const [showChatToast, setShowChatToast] = useState(false);
    


    useEffect(() => {
        const fetchtimeOffRequestData = async () => {
            if (loggedinUser) {
                const isUserAdmin = isAdminUser(loggedinUser?.stsTokenManager);
                const data = await fetchUserNotificationPreferences(loggedinUser.uid);
                if (timeOffRequest !== null && isUserAdmin && data !== null && data.timeOffEnabled)  {
                    pushNotification(
                        "Time Off Request",
                        `A new request leave by ${timeOffRequest.name} from ${formatDate(timeOffRequest.startDate, "DD MMM, YYYY")} to ${formatDate(timeOffRequest.endDate, "DD MMM, YYYY")} `,
                        () => {
                          navhelper.push("AdminTimeOffScreen");
                          setNotificationClicked(true)

                        }
                    )
                    setDialogRoute("AdminTimeOffScreen");
                    setDialogTitle("Time Off Request");
                    setConfirmText("Detail");
                    setToastMessage(`A new request leave by ${timeOffRequest.name} from ${formatDate(timeOffRequest.startDate, "DD MMM, YYYY")} to ${formatDate(timeOffRequest.endDate, "DD MMM, YYYY")} `);
                    setShowToast(true);
                    setTimeOffRequest(null);
                }
            }
        };

        fetchtimeOffRequestData();
    }, [timeOffRequest, setTimeOffRequest]);

    useEffect(() => {
        const fetchMessageData = async () => {
            if (loggedinUser) {
                const data = await fetchUserNotificationPreferences(loggedinUser.uid);
                if (message !== null && data !== null && data.chatEnabled) {
                    pushNotification(
                        "Message",
                        `You have a new message from ${message.senderName}`,
                        () => {
                          navhelper.push(`UserChatScreen?selectedUserId=${message.senderId}`);
                        }
                      );
                      setDialogRoute(`UserChatScreen?selectedUserId=${message.senderId}`)
                   
                      setToastMessage(`You have a new message from ${message.senderName}`);
                      setShowChatToast(true);
                    setMessage(null);
                   
                }
            }
        }
        fetchMessageData();
    }, [message, setMessage])
   

   
    return (
        <div>
            {/* Display the latest notification */}

            <Dialog
                confirm={true}
                message={toastMessage}
                onDialogClose={() => setShowToast(false)}
                handleDialogConfirm={() => {
                    if(dialogRoute==="AdminTimeOffScreen"){
                        setNotificationClicked(true)
                    }
                    navhelper.push(dialogRoute);
                    setShowToast(false);
                }}
                isDialogVisible={showToast}
                title={dialogTitle}
                confirmText={confirmText}
                cancelText="Close"
            />
<ToastNotification message={toastMessage} visible={showChatToast} link={dialogRoute} heading='Chat Message'onClose={()=>setShowChatToast(false)}/>

        </div>
    );
};

export default NotificationAlert;